import { motion } from "framer-motion";

const CHAPTERS = [
  {
    number: "01",
    title: "Late Model",
    text: "Every vehicle is current-generation or newer — no exceptions.",
  },
  {
    number: "02",
    title: "Detailed Daily",
    text: "Professional interior and exterior detail before every reservation.",
  },
  {
    number: "03",
    title: "Fully Insured",
    text: "$1.5M commercial liability coverage on every vehicle in the fleet.",
  },
  {
    number: "04",
    title: "CPUC Licensed",
    text: "California Public Utilities Commission certified TCP carrier.",
  },
];

export default function Standards() {
  return (
    <section
      id="standards"
      data-testid="fleet-standards-section"
      className="scroll-mt-20 border-t border-line bg-abyss py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-14 sm:mb-20"
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-champagne">
            02 — Fleet Standards
          </p>
          <h2 className="mt-4 max-w-2xl font-serif text-3xl font-light tracking-tight text-bone sm:text-5xl">
            Every vehicle. Every ride. <span className="italic text-champagne">Every time.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-px border border-line bg-line sm:grid-cols-2 lg:grid-cols-4">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.number}
              data-testid={`standard-chapter-${c.number}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="group bg-abyss p-8 transition-colors duration-500 hover:bg-surface"
            >
              <p className="text-outline font-serif text-6xl font-light transition-colors duration-500 group-hover:text-champagne">
                {c.number}
              </p>
              <h3 className="mt-6 font-serif text-xl font-medium tracking-tight text-bone">
                {c.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-smoke">{c.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
